import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMG } from "@/data/content";

const services = [
  {
    id: "catering",
    eyebrow: "01 — Catering",
    title: "Catering",
    img: IMG.table_setting,
    body:
      "Bespoke menus and refined service for corporate office meetings, backyard gatherings with family and friends, and intimate at-home multi-course menus. Every event is built from scratch around the occasion and the season — from a working lunch in the boardroom to a slow Sunday afternoon on the patio.",
    bullets: [
      "Corporate office meetings, lunches & client entertaining",
      "Backyard gatherings for family and friends",
      "Intimate at-home multi-course tasting menus (coming September 2026)",
      "On-site finishing and tableside presentation",
    ],
  },
  {
    id: "private-chef",
    eyebrow: "02 — Private Chef",
    title: "Private Chef",
    comingSoon: true,
    img: IMG.chef_sauce,
    body:
      "An evening of restaurant-calibre cuisine, prepared inside your home. From a quiet anniversary for two to a dinner party for sixteen — your kitchen, our craft, no compromise.",
    bullets: [
      "Tasting menus & multi-course experiences",
      "Bespoke menu shaped around guest preferences",
      "Full grocery sourcing, prep, service & clean-up",
      "Wine recommendations and pairing notes",
    ],
  },
  {
    id: "meal-prep",
    eyebrow: "03 — Meal Prep",
    title: "Meal Prep",
    img: IMG.meal_prep_plated,
    body:
      "Chef-crafted weekly meals, tailored to your nutritional goals and lifestyle. Premium ingredients, balanced macros, and the kind of flavour that makes eating well effortless.",
    bullets: [
      "Weekly rotating menus, fully customizable",
      "Calibrated for performance, wellness, or family",
      "Delivered fresh, ready-to-enjoy",
      "Allergen-aware & dietary preference friendly",
    ],
  },
];

export default function Services() {
  return (
    <div data-testid="services-page">
      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-16 lg:pt-24 pb-12">
        <div className="eyebrow mb-6">Services</div>
        <h1 className="font-serif-display text-5xl lg:text-7xl max-w-4xl leading-[1.04]" style={{ color: "var(--ooe-ink)" }}>
          A trusted meal with peace of mind, for any
          <em className="not-italic" style={{ color: "var(--ooe-brand)" }}> occasion.</em>
        </h1>
        <p className="mt-8 max-w-2xl text-[16px] leading-relaxed" style={{ color: "var(--ooe-ink-2)" }}>
          Three services, one mission — delivering refined, nourishing &amp;
          whole food cuisine.
        </p>
      </section>

      {services.map((s, i) => (
        <section key={s.id} id={s.id} className="py-20 lg:py-28" style={{ background: i % 2 === 0 ? "var(--ooe-bg)" : "var(--ooe-bg-2)" }}>
          <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
            <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <img src={s.img} alt={s.title} className="w-full h-[560px] object-cover" style={{ border: "1px solid var(--ooe-border)" }} />
            </div>
            <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1 lg:pr-10" : "lg:pl-6"}`}>
              <div className="eyebrow mb-5">{s.eyebrow}</div>
              <h2 className="font-serif-display text-4xl lg:text-6xl leading-tight flex flex-wrap items-baseline gap-x-4" style={{ color: "var(--ooe-ink)" }}>
                {s.title}
                {s.comingSoon && (
                  <span className="eyebrow" style={{ fontSize: 11, color: "var(--ooe-brand)" }}>Coming in September 2026</span>
                )}
              </h2>
              <p className="mt-7 text-[16px] leading-relaxed" style={{ color: "var(--ooe-ink-2)" }}>{s.body}</p>
              <ul className="mt-8 space-y-3">
                {s.bullets.map((b) => (
                  <li key={b} className="flex gap-3 text-[15px]" style={{ color: "var(--ooe-ink)" }}>
                    <span style={{ color: "var(--ooe-brand)" }}>—</span>{b}
                  </li>
                ))}
              </ul>
              <Link to="/contact" className="btn-primary mt-10 inline-flex" data-testid={`service-${s.id}-cta`}>
                Inquire about {s.title} <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
